export const constructAgreementHtml = (
    template: string,
    name: string,
    title: string,
    date: string,
    signatureFont?: string,
    ipAddress?: string
) => {
    const base = template
        .replace(/{{#NAME}}/g, name)
        .replace(/{{#TITLE}}/g, title)
        .replace(/{{#DATE}}/g, `${date}`)
        .replace(/{{#IPADDRESS}}/g, !ipAddress ? 'unknown' : ipAddress)
        .replace(/{{dateTime}}/g, `${date}`)
        .replace(/{{ipAddress}}/g, !ipAddress ? 'unknown' : ipAddress);

    if (signatureFont) {
        return base.replace(/{{#SIGNATURE}}/g, `<span style="font-size: 120%; font-family: '${signatureFont}';">${name}</span>`);
    } else {
        return base.replace(/{{#SIGNATURE}}/g, '__________________________________________');
    }
};
